export default __webpack_public_path__ + "static/media/sample-FP-L5.75a79082.png";